import { useParams, useSearchParams } from 'react-router-dom';
import SimpleReducer from 'reducers/SimpleReducer';
import { useImmerReducer } from 'use-immer';

const useForm = (initialData = {}, logName, draftName) => {
  const [state, dispatch] = useImmerReducer(SimpleReducer, initialData);
  const [searchParams, setSearchParams] = useSearchParams();
  const { id } = useParams();

  // functions
  const addDetail = (detail) => {
    if (!detail.extra && state.details.find((x) => x.uid === detail.uid))
      return;
    if (!detail.uid) detail.uid = Math.random();

    dispatch({
      key: 'details',
      value: [...state.details, detail],
    });
    dispatch({
      key: 'recentlyRemoved',
      value: state.recentlyRemoved.filter((x) => x.uid !== detail.uid),
    });
    log();

    return detail;
  };

  const removeDetail = (detail) => {
    const myDetail = state.details.find((x) => x.uid === detail.uid);
    dispatch({
      key: 'details',
      value: state.details.filter((x) => x.uid !== detail.uid),
    });

    if (myDetail)
      dispatch({
        key: 'recentlyRemoved',
        value: [...state.recentlyRemoved, myDetail],
      });
    log();

    return detail;
  };

  const adjustDetail = (detail, key, value) => {
    const details = [...state.details];
    const myDetail = details.find((x) => x.uid === detail.uid);
    if (myDetail) {
      details[details.indexOf(myDetail)] = {
        ...detail,
        [key]: value,
      };
      dispatch({
        key: 'details',
        value: details,
      });
    }
    log();
    return detail;
  };

  const bulkAdjustDetails = (detail, changes) => {
    const details = [...state.details];
    const myDetail = details.find((x) => x.uid === detail.uid);
    if (myDetail) {
      details[details.indexOf(myDetail)] = {
        ...detail,
        ...changes,
      };
      dispatch({
        key: 'details',
        value: details,
      });
    }
    log();
    return detail;
  };

  const reset = () => {
    dispatch({
      hardSet: initialData,
    });
    log();
  };

  const setFormState = (props) => {
    dispatch(props);
    log();
  };

  const log = () => {
    if (logName) {
      dispatch({
        log: {
          name: logName,
          keys: ['details', 'info'],
        },
      });
    }
  };

  return {
    formState: state,
    setFormState,
    addDetail,
    removeDetail,
    adjustDetail,
    bulkAdjustDetails,
    reset,
  };
};

export default useForm;
